"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Rarity = void 0;
const validation_1 = require("../validation");
var Rarity;
(function (Rarity) {
    // UNIQUE = 'unique',
    // MYTHIC = 'mythic',
    // LEGENDARY = 'legendary',
    // EPIC = 'epic',
    // RARE = 'rare',
    // UNCOMMON = 'uncommon',
    // COMMON = 'common',
    Rarity["RARE"] = "rare";
    Rarity["SCARCE"] = "scarce";
    Rarity["EPIC"] = "epic";
    Rarity["MYTHICAL"] = "mythical";
    Rarity["LEGENDARY"] = "legendary";
})(Rarity = exports.Rarity || (exports.Rarity = {}));
(function (Rarity) {
    Rarity.schema = {
        type: 'string',
        enum: Object.values(Rarity),
    };
    Rarity.validate = validation_1.generateValidator(Rarity.schema);
    const maxSupplyByRarity = {
        [Rarity.LEGENDARY]: 10,
        [Rarity.MYTHICAL]: 40,
        [Rarity.EPIC]: 60,
        [Rarity.SCARCE]: 90,
        [Rarity.RARE]: 800,
    };
    const lightColorByRarity = {
        [Rarity.LEGENDARY]: '#f94545',
        [Rarity.MYTHICAL]: '#63effc',
        [Rarity.EPIC]: '#A657ED',
        [Rarity.SCARCE]: '#f5994f',
        [Rarity.RARE]: '#3AD682',
    };
    const colorByRarity = {
        [Rarity.LEGENDARY]: '#ea2929',
        [Rarity.MYTHICAL]: '#18dcff',
        [Rarity.EPIC]: '#842DDA',
        [Rarity.SCARCE]: '#ee8229',
        [Rarity.RARE]: '#36CF75',
    };
    function getMaxSupply(rarity) {
        return maxSupplyByRarity[rarity];
    }
    Rarity.getMaxSupply = getMaxSupply;
    function getColor(rarity) {
        return colorByRarity[rarity];
    }
    Rarity.getColor = getColor;
    function getGradient(rarity) {
        return [lightColorByRarity[rarity], colorByRarity[rarity]];
    }
    Rarity.getGradient = getGradient;
})(Rarity = exports.Rarity || (exports.Rarity = {}));
//# sourceMappingURL=rarity.js.map